import { render } from "./DocumentShow.vue?vue&type=template&id=59a4419f"
import script from "./DocumentShow.vue?vue&type=script&lang=js"
export * from "./DocumentShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__